import Head from "next/head";
import { wrapper } from "@/redux/Store";

import FestivalBanner from "@/containers/FestivalBanner";
const DiwaliCheatSheetPage = () => (
  <>
    <Head>
      <title>Shyft</title>
    </Head>
    <main>
      <FestivalBanner />
    </main>
  </>
);

export default DiwaliCheatSheetPage;

export const getStaticProps = wrapper.getStaticProps(() => async () => {
  return {
    props: {},
    revalidate: 60 * 60 * 24 * 15, // revalidate in 15 days
  };
});
